<mat-toolbar class="topbar gap-5">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if (showToggle) {
    <button mat-icon-button (click)="toggleCollapsed.emit()" class="d-flex justify-content-center align-items-center">
      <i class="iconify icon-20 d-flex" data-icon="solar:hamburger-menu-line-duotone"></i>
    </button>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Mobile Menu -->
  @if (!showToggle) {
    <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center align-items-center">
      <i class="iconify icon-20 d-flex" data-icon="solar:hamburger-menu-line-duotone"></i>
    </button>
  }
  <!-- --------------------------------------------------------------- -->

  <span class="flex-1-auto"></span>

  <!--<button mat-icon-button (click)="toggleMobileFilterNav.emit()"
          class="d-flex d-lg-none justify-content-center align-items-center">
    <i class="iconify icon-20 d-flex" data-icon="solar:menu-dots-outline"></i>
  </button>-->

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!--<button mat-icon-button [matMenuTriggerFor]="notificationmenu" aria-label="Notifications"
          class="d-flex align-items-center justify-content-center m-r-5">
    <i class="iconify icon-20 d-flex" data-icon="solar:bell-line-duotone"></i>
  </button>
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0">Notifications</h6>
      <span class="m-l-auto">
        <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">5 new</span>
      </span>
    </div>

    @for (notification of notifications; track notification.title) {
      <button mat-menu-item class="p-x-30 p-y-12">
        <div class="d-flex align-items-center">
        <span
          class="flex-shrink-0 text-{{ notification.color }} bg-light-{{
            notification.color
          }} rounded-circle icon-48 d-flex align-items-center justify-content-center"
        >
          <i-tabler
            name="{{ notification.icon }}"
            class="icon-20 d-flex"
          ></i-tabler>
        </span>
          <div class="m-l-16 w-100">
            <div class="d-flex align-items-center justify-content-between w-100">
              <h5 class="f-s-14 f-w-600 m-0">
                {{ notification.title }}
              </h5>
              <span class="d-block f-s-12 m-l-auto">
              {{ notification.time }}</span
              >
            </div>
            <span class="d-block text-truncate f-s-12 w-75">{{
                notification.subtitle
              }}</span>
          </div>
        </div>
      </button>
    }

    <div class="p-y-12 p-x-32">
      <button mat-flat-button color="primary" class="w-100">
        See all Notifications
      </button>
    </div>
  </mat-menu>-->

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button [matMenuTriggerFor]="flags" mat-icon-button>
    <img
      [src]="selectedLanguage.icon"
      class="rounded-circle object-cover icon-20"
    />
  </button>
  <mat-menu #flags="matMenu" class="cardWithShadow">
    @for (lang of languages; track lang.icon) {
      <button mat-menu-item (click)="changeLanguage(lang)">
        <div class="d-flex align-items-center">
          <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20"
          />
          <span class="f-s-14">{{ lang.language }}</span>
        </div>
      </button>
    }
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-button [matMenuTriggerFor]="profilemenu" aria-label="Profile" class="profile-btn">
    <div class="d-flex align-items-center gap-4">
      <img *ngIf="user?.avatar; else elseImage" src="{{user?.avatar}}" class="rounded-circle object-cover icon-35 profile-dd" width="35"/>

      <ng-template #elseImage>
        <img src="/assets/images/users/user-img.jpg" class="rounded-circle object-cover icon-35 profile-dd" width="35"/>
      </ng-template>

      <i data-icon="solar:alt-arrow-down-bold" class="iconify f-s-8"></i>
    </div>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="p-x-32 p-y-16">
      <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">

        <div *ngIf="user?.avatar; else elseImageUser" [style.backgroundImage]="'url('+user?.avatar+')'" class="rounded-circle align-items-lg-center" style="width: 56px; height: 56px; background-size: cover; margin: auto;"></div>


        <ng-template #elseImageUser>
          <img src="/assets/images/users/user-img.jpg" class="rounded-circle" width="56"/>
        </ng-template>
        <div class="m-l-16">
          <h6 class="f-s-14 f-w-600 m-0 d-flex align-items-center">
            {{user?.name}} {{user?.lastname}}
          </h6>
          <span class="text-muted"> {{user?.email}} </span>
        </div>
      </div>
    </div>
    <div class="p-x-32 p-b-16">
      @for (profile of profiledd; track profile.title) {
        <a class="p-8 text-decoration-none d-block text-hover-primary" [routerLink]="[profile.link]">
          <div class="d-flex align-items-center">
            <h5 class="f-s-14 f-w-600 m-0 lh-md hover-text">
              {{ profile.title }}
            </h5>
            @if (profile.new) {
              <span class="bg-light-error text-error rounded p-x-8 p-y-2 f-w-500 f-s-12 m-l-4">5</span>
            }
          </div>
        </a>
      }
    </div>
    <div class="p-x-32 p-b-16">
      <a class="p-8 text-decoration-none d-block text-hover-primary" routerLink="/users/user-profile">
        <div class="d-flex align-items-center">
          <h5 class="f-s-14 f-w-600 m-0 lh-md hover-text"> {{"header.profile" | translate}}</h5>
        </div>
      </a>
      <a class="p-8 text-decoration-none d-block text-hover-primary" (click)="logout()" href="#">
        <div class="d-flex align-items-center">
          <h5 class="f-s-14 f-w-600 m-0 lh-md hover-text"> {{"header.logout" | translate}} </h5>
        </div>
      </a>
    </div>
  </mat-menu>
</mat-toolbar>

